const TypeOfEmployment = {
  Default: 0,
  Permanent: 1,
  Temporary: 2,
};

export default TypeOfEmployment;
